import { Component, Input } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateModuleComponent } from "../create-module/create-module.component";
import { FirmwareService, ModuleName} from "../services/firmware/firmware.service";

@Component({
  selector: 'dcc-module-card-display',
  templateUrl: './module-card-display.component.html',
  styleUrls: ['./module-card-display.component.scss']
})
export class ModuleCardDisplayComponent {
  @Input() module: ModuleName;
  @Input() editable: boolean = true;

  constructor(
    private modalService: NgbModal,
    private firmwareService: FirmwareService
  ) { }

  editModule() {
    const modal = this.modalService.open(CreateModuleComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.isUpdate = true;
    modal.componentInstance.moduleToUpdate = this.module;
    modal.componentInstance.closePage.subscribe(async () => await this.getModuleData(this.module.name));
  }

  async getModuleData(name: string) {
    this.module = await this.firmwareService.getModuleByName(name);
  }
}
